module.exports = __webpack_public_path__ + "img/5.4c51d414.jpg";